import React from "react";
import EPostaLogo from "../../layout/header/ePosta-logo.png";
import DitLogo from "../../layout/header/dokit-logo.png";
import ZeleniPostaLogo from "../../layout/header/posta_logo_zeleni.png";
import LogoHkms from "../../layout/header/logo-hkms.png";

export const themes = {
  yellow: {
    themeColor: "yellow",
    fontFamily: "Graublau",
    navColor: "black",
    navText: "white",
    navLinkColor: "black",
    cityClass: "location-active",
    lineColor: "warning",
    iconColor: "warning",
    logo: EPostaLogo,
    footer: true,
  },
  blue: {
    themeColor: "blue",
    fontFamily: "Museo300",
    navColor: "white",
    navText: "black",
    navLinkColor: "white",
    cityClass: "location-active-blue",
    lineColor: "black",
    iconColor: "info",
    logo: DitLogo,
    footer: false,
  },
  green: {
    themeColor: "primary-light", //"primary-light"
    fontFamily: "Graublau",
    navColor: "white",
    navText: "black",
    navLinkColor: "black",
    cityClass: "location-active-blue",
    lineColor: "primary-light",
    iconColor: "primary",
    logo: ZeleniPostaLogo,
    footer: true,
    footerVersion: "v2",
  },
  purple: {
    themeColor: "purple",
    fontFamily: "Museo300",
    navColor: "white",
    navText: "black",
    navLinkColor: "black",
    cityClass: "location-active-blue",
    lineColor: "purple-light",
    footerLineColor: "purple",
    iconColor: "purple-dark",
    hrLine: "purple-dark",
    logo: LogoHkms,
    footer: true,
    footerVersion: "v2",
    tableSeparatorLine: "grey",
    tableSeparatorLineDark: "grey-darker",
    purpleCircle: "purple-1",
    purpleWarning: "purple-warning",
    voteGreen: "vote-green",
    voteRed: "vote-red",
    voteGrey: "vote-grey",
  },
};

export const ThemeContext = React.createContext(themes.green); //green
